import axios from 'axios';
import {API_CONFIG} from './config';
import {Article, ArticlesResponse} from '../types/article';

const api = axios.create({
  baseURL: API_CONFIG.API_URL,
  timeout: 30000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// Fetch all articles
export const fetchArticles = async (page = 1): Promise<{posts: Article[]; meta: any}> => {
  try {
    const response = await api.get<ArticlesResponse>(API_CONFIG.POSTS, {
      params: { page, limit: 15 },
    });
    
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to fetch articles');
    }
    
    return {
      posts: response.data.posts,
      meta: response.data.meta,
    };
  } catch (error) {
    console.error('Error fetching articles:', error);
    throw error;
  }
};

// Search articles
export const searchArticles = async (query: string, page = 1, limit = 15): Promise<{posts: Article[]; meta: any}> => {
  try {
    const response = await api.get<ArticlesResponse>(API_CONFIG.SEARCH, {
      params: { q: query, page, limit },
    });
    
    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to search articles');
    }
    
    return {
      posts: response.data.posts,
      meta: response.data.meta,
    };
  } catch (error) {
    console.error('Error searching articles:', error);
    throw error;
  }
};

// Fetch single article
export const fetchArticle = async (id: number): Promise<Article> => {
    try {
      const response = await api.get<{success: boolean; post: Article}>(`${API_CONFIG.POSTS}/${id}`);
      
      if (!response.data.success) {
        throw new Error('Failed to fetch article');
      }
      
      return response.data.post;
    } catch (error) {
      console.error('Error fetching article:', error);
      throw error;
    }
  };

// Text-to-Speech
export const synthesizeTTS = async (text: string): Promise<ArrayBuffer> => {
  try {
    const response = await api.post(
      API_CONFIG.TTS,
      {text},
      {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'audio/mpeg',
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error synthesizing TTS:', error);
    throw error;
  }
};

export default api;
